import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../http.service';

@Component({
  selector: 'app-agent-credit-management',
  templateUrl: './agent-credit-management.component.html',
  styleUrls: ['./agent-credit-management.component.scss']
})
export class AgentCreditManagementComponent implements AfterViewInit {

  private agent_uuid;
  public player: any = {};
  public games: any = [];
  public labels: any = [];
  constructor(private activatedRoute: ActivatedRoute, private http: HttpService) { 
    this.activatedRoute.params.subscribe((val) => {
      this.agent_uuid = val.agent_uuid
    })
  }

  ngAfterViewInit(): void {
    this.init()
  }

  async init() {
    const gl:any = await this.http.post('/admin/agent/games/list', {agent_uuid: this.agent_uuid});
    this.games = gl.games;
    this.player = gl.player;
  }

  async saveGameSetting() {
    if (this.player?.is_suspended == 1) return;
    const s:any = await this.http.post('/admin/agent/rate/save', {games: this.games, agent_uuid: this.agent_uuid});
    if (s.status) {
      alert("Player rolling game rate saved.")
    } else {
      alert("Player rolling game rate was not saved.")
    }
  }

}
